// import React, { useEffect, useState } from "react";
// import { CryptoData, Currency } from "@/types/Currency.tsx";
// import GenericApi from "@/api/genericApi";
// import {
//   CryptoDataQueryKey,
//   ExchangeSettingsQueryKey,
// } from "@/config/constants/QueryKeys";
// import { ApiResponse } from "@/types/Api";
// import { useQuery } from "@tanstack/react-query";
// import CurrencyOption from "./CurrencyOption";
// import { Balance } from "@/types/Balance.tsx";
// import { ApiRoutes } from "@/config/routes/ApiRoutes";
// import { ExchangeSettings } from "@/types/Exchange";
// import { isSNS } from "@/utils/utils";

// interface Props {
//   currencie: string;
//   name: string;
//   editable: boolean;
//   options: Currency[];
//   onChangeInput: (
//     value: number,
//     index: number,
//     {
//       inputFocusedUp,
//       inputFocusedDown,
//     }: {
//       inputFocusedUp: boolean;
//       inputFocusedDown: boolean;
//     }
//   ) => void;
//   onChooseOption: (option: Currency, index: number) => void;
//   defaultOption: Currency;
//   index: number;
//   value?: number;
//   isLoading: boolean;
//   hasError: boolean;
//   isUp: boolean;
//   currency: string;
//   balance: Balance[] | null;
//   isPos?: boolean;
// }

// const CurrenciesSelector: React.FC<Props> = ({
//   isUp,
//   name,
//   options,
//   onChooseOption,
//   defaultOption,
//   value,
//   onChangeInput,
//   isLoading,
//   hasError,
//   currency,
//   balance,
// }) => {
//   const isBej = name.includes("line--bej");

//   const selectedBalance = balance?.find((b) => b.currency === currency);
//   const [focused, setFocused] = React.useState(false);

//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState<Currency>({
//     ...defaultOption,
//   });

//   // const debounceValue = useDebounce(value, 500);

//   const [isNewFiat, setIsNewFiat] = useState(false);

//   const handleMouseEnter = () => {
//     setIsOpen(true);
//   };

//   const handleMouseLeave = () => {
//     setIsOpen(false);
//   };

//   const handleOptionClick = (option: Currency) => {
//     setSelectedOption(option);
//     setIsOpen(false);
//     onChooseOption(option, isUp ? 0 : 1);
//     if (option.type === "fiat") {
//       setIsNewFiat(true);
//     } else {
//       setIsNewFiat(false);
//     }
//   };

//   const getVal = (value: number) => {
//     const valueAsString = String(value);

//     if (valueAsString === "0") {
//       return "";
//     }

//     if (valueAsString[0] === "0" && valueAsString[1] !== ".") {
//       return valueAsString.slice(1);
//     }

//     return valueAsString;
//   };

//   const url = `https://min-api.cryptocompare.com/data`;

//   const { data: cryptoData, error } = useQuery<ApiResponse<CryptoData>>({
//     queryFn: async () =>
//       GenericApi.get<CryptoData>(
//         `/pricemultifull?fsyms=${currency}&tsyms=${currency}`,
//         url
//       ),
//     queryKey: [CryptoDataQueryKey, currency],
//   });

//   const [inputValue, setInputValue] = useState<string>("");
//   const onFocus = () => setFocused(true);
//   const onBlur = () => setFocused(false);

//   const { data: exchangeSettings } = useQuery<ApiResponse<ExchangeSettings>>({
//     queryFn: async () =>
//       GenericApi.get<ExchangeSettings>(ApiRoutes.EXCHANGESETTINGS),
//     queryKey: [ExchangeSettingsQueryKey],
//   });

//   useEffect(() => {
//     setInputValue(getVal(value ?? 0));
//   }, [value]);

//   const getMediaLink = () => {
//     if (currency) {
//       return cryptoData?.data?.RAW?.[currency]?.[currency]?.IMAGEURL;
//     }

//     return null;
//   };

//   const mediaLink = getMediaLink();

//   const flagUrls: Record<string, string> = {
//     EUR: "https://flagcdn.com/w320/eu.png",
//     USD: "https://flagcdn.com/w320/us.png",
//     RON: "https://flagcdn.com/w320/ro.png",
//     GBP: "https://flagcdn.com/w320/gb.png",
//     JPY: "https://flagcdn.com/w320/jp.png",
//     PLN: "https://flagcdn.com/w320/pl.png",
//     AUD: "https://flagcdn.com/w320/au.png",
//     CAD: "https://flagcdn.com/w320/ca.png",
//     CHF: "https://flagcdn.com/w320/ch.png",
//     // Adaugă aici alte monede relevante
//   };

//   const imageUrl = flagUrls?.[currency]
//     ? flagUrls[currency] // Use flag URL if available
//     : mediaLink
//     ? `https://www.cryptocompare.com${mediaLink}`
//     : "https://via.placeholder.com/24";

//   // if up is fiat, filter options to only include fiat currencies and down to only include non-fiat currencies

//   if (error || cryptoData?.error) {
//     return <div>{cryptoData?.error?.message ?? "Something went wrong"}</div>;
//   }

//   //   return (
//   //     <div className={`${name} flex flex-col gap-1`}>
//   //       <div className="text-left w-full text-[1rem] font-[400] pb-[8px]">
//   //         {isUp ? "You send" : "You get"}
//   //       </div>
//   //       <div className="flex justify-between w-full pb-[1rem]">
//   //         <div
//   //           className={`currenciesSelector ${
//   //             isBej ? "currenciesSelector--bej" : ""
//   //           }`}
//   //           onMouseEnter={handleMouseEnter}
//   //           onMouseLeave={handleMouseLeave}
//   //         >
//   //           <div className="z-up">
//   //             <div className="circle">
//   //               {" "}
//   //               <img
//   //                 className="w-[55px] h-[55px] rounded-full object-cover"
//   //                 src={imageUrl}
//   //                 alt="Crypto"
//   //               />
//   //             </div>
//   //           </div>
//   //           <div className="w-full`">
//   //             <div className="flex gap-4 items-center w-fit">
//   //               <div
//   //                 data-text={selectedOption.code}
//   //                 className="z-up text flex flex-col items-start justify-start"
//   //               >
//   //                 {selectedOption.code}
//   //               </div>

//   //               <div>
//   //                 <svg
//   //                   width="13"
//   //                   height="11"
//   //                   viewBox="0 0 13 11"
//   //                   fill="none"
//   //                   xmlns="http://www.w3.org/2000/svg"
//   //                   className={isOpen ? "rotate180" : "reverseRotate180"}
//   //                 >
//   //                   <path
//   //                     id="Polygon 3"
//   //                     d="M7.35044 9.6252C6.95955 10.2571 6.04045 10.2571 5.64956 9.6252L0.948823 2.02607C0.536717 1.35987 1.0159 0.5 1.79926 0.5L11.2007 0.500001C11.9841 0.500001 12.4633 1.35987 12.0512 2.02607L7.35044 9.6252Z"
//   //                     fill="#222B45"
//   //                   />
//   //                 </svg>
//   //               </div>
//   //             </div>

//   //             {isUp ? (
//   //               <div className="flex justify-start items-center gap-2 w-full absolute left-[75px]">
//   //                 {exchangeSettings?.data?.balance_enabled === true && (
//   //                   <span className="text-[#C2C2C2] font-normal text-lg text-nowrap">
//   //                     {!isNewFiat
//   //                       ? `Balance: ${
//   //                           Number(selectedBalance?.balance).toFixed(4) ?? "N/A"
//   //                         }
//   //                   ${selectedBalance?.currency ?? "N/A"}`
//   //                       : ""}
//   //                   </span>
//   //                 )}
//   //               </div>
//   //             ) : (
//   //               <div></div>
//   //             )}
//   //           </div>
//   //           {isOpen && (
//   //             <div className="dropDownComponent__menu__currencies ">
//   //               {options.map((option) => (
//   //                 <CurrencyOption
//   //                   option={option}
//   //                   handleClickOption={handleOptionClick}
//   //                   key={option.code}
//   //                 />
//   //               ))}
//   //             </div>
//   //           )}
//   //         </div>

//   //         <div className="">
//   //           <form>
//   //             {isLoading && !focused ? (
//   //               <div
//   //                 className="inline-block h-10 w-10 animate-spin rounded-full border-[7px] border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
//   //                 role="status"
//   //               >
//   //                 <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
//   //                   Loading...
//   //                 </span>
//   //               </div>
//   //             ) : hasError && !focused ? (
//   //               <div className="text-red-500">No rate found</div>
//   //             ) : (
//   //               <input
//   //                 onFocus={onFocus}
//   //                 onBlur={onBlur}
//   //                 className="inputNumber !text-[1.75rem]"
//   //                 type="text"
//   //                 id="number"
//   //                 step="any"
//   //                 placeholder="0"
//   //                 name="number"
//   //                 min="0"
//   //                 autoComplete="off"
//   //                 value={inputValue}
//   //                 onChange={(e) => {
//   //                   const val = e.target.value.replace(",", ".");

//   //                   // Reject anything with multiple leading zeros (except "0", "0.xxx")
//   //                   const valid = /^([1-9]\d*|0)?(\.\d*)?$/.test(val);

//   //                   if (val === "" || valid) {
//   //                     setInputValue(val);

//   //                     // Trigger change only if valid number (not just ".", empty)
//   //                     if (val !== "" && val !== "." && !isNaN(Number(val))) {
//   //                       onChangeInput(Number(val), isUp ? 0 : 1, {
//   //                         inputFocusedUp: focused && isUp,
//   //                         inputFocusedDown: focused && !isUp,
//   //                       });
//   //                     }
//   //                   }
//   //                 }}
//   //               />
//   //             )}
//   //           </form>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );

//   return (
//     <div className={`${name} flex flex-col gap-1`}>
//       <div
//         className={`text-left w-full text-[1rem] font-[400] pb-[8px] ${
//           isSNS() ? "text-[#727272] font-[inter]" : "text-black"
//         }`}
//       >
//         {isUp ? "You send" : "You get"}
//       </div>
//       <div className="flex justify-between w-full pb-[1rem]">
//         <div
//           className={`currenciesSelector ${
//             isBej ? "currenciesSelector--bej" : ""
//           }`}
//           onMouseEnter={handleMouseEnter}
//           onMouseLeave={handleMouseLeave}
//         >
//           <div className="z-up">
//             <div className={`circle ${isSNS() ? "!bg-transparent" : ""}`}>
//               {" "}
//               <img
//                 className="w-[55px] h-[55px] rounded-full object-cover"
//                 src={imageUrl}
//                 alt="Crypto"
//               />
//             </div>
//           </div>
//           <div className="w-full`">
//             <div className="flex gap-4 items-center w-fit">
//               <div
//                 data-text={selectedOption.code}
//                 className="z-up text flex flex-col items-start justify-start"
//               >
//                 {selectedOption.code}
//               </div>

//               <div>
//                 {isSNS() ? (
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="11"
//                     height="11"
//                     viewBox="0 0 11 11"
//                     fill="none"
//                   >
//                     <path
//                       d="M10.6961 0.144357L5.54772 5.29275L0.402913 0.147951L0.402114 4.95086L5.55131 10.1001L10.6931 4.95825L10.6961 0.144357Z"
//                       fill="white"
//                     />
//                   </svg>
//                 ) : (
//                   <svg
//                     width="13"
//                     height="11"
//                     viewBox="0 0 13 11"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                     className={isOpen ? "rotate180" : "reverseRotate180"}
//                   >
//                     <path
//                       id="Polygon 3"
//                       d="M7.35044 9.6252C6.95955 10.2571 6.04045 10.2571 5.64956 9.6252L0.948823 2.02607C0.536717 1.35987 1.0159 0.5 1.79926 0.5L11.2007 0.500001C11.9841 0.500001 12.4633 1.35987 12.0512 2.02607L7.35044 9.6252Z"
//                       fill="#222B45"
//                     />
//                   </svg>
//                 )}
//               </div>
//             </div>

//             {isUp ? (
//               <div className="flex justify-start items-center gap-2 w-full absolute left-[75px]">
//                 {exchangeSettings?.data?.balance_enabled === true && (
//                   <span className="text-[#C2C2C2] font-normal text-lg text-nowrap">
//                     {!isNewFiat
//                       ? `Balance: ${
//                           Number(selectedBalance?.balance).toFixed(4) ?? "N/A"
//                         }
//                   ${selectedBalance?.currency ?? "N/A"}`
//                       : ""}
//                   </span>
//                 )}
//               </div>
//             ) : (
//               <div></div>
//             )}
//           </div>
//           {isOpen && (
//             <div
//               className={`dropDownComponent__menu__currencies ${
//                 isSNS() ? "bg-[#383838] border border-[#383838]" : ""
//               }`}
//             >
//               {options.map((option) => (
//                 <CurrencyOption
//                   option={option}
//                   handleClickOption={handleOptionClick}
//                   key={option.code}
//                 />
//               ))}
//             </div>
//           )}
//         </div>

//         <div className="">
//           <form>
//             {isLoading && !focused ? (
//               <div
//                 className="inline-block h-10 w-10 animate-spin rounded-full border-[7px] border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
//                 role="status"
//               >
//                 <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
//                   Loading...
//                 </span>
//               </div>
//             ) : hasError && !focused ? (
//               <div className="text-red-500">No rate found</div>
//             ) : (
//               <input
//                 onFocus={onFocus}
//                 onBlur={onBlur}
//                 className={`inputNumber !text-[1.75rem] ${
//                   isSNS() ? "!text-white" : ""
//                 }`}
//                 type="number"
//                 id="number"
//                 step="any"
//                 inputMode="decimal"
//                 placeholder="0"
//                 name="number"
//                 min="0"
//                 autoComplete="off"
//                 value={inputValue}
//                 onChange={(e) => {
//                   const val = e.target.value.replace(",", ".");

//                   // Reject anything with multiple leading zeros (except "0", "0.xxx")
//                   const valid = /^([1-9]\d*|0)?(\.\d*)?$/.test(val);

//                   if (val === "" || valid) {
//                     setInputValue(val);

//                     // Trigger change only if valid number (not just ".", empty)
//                     if (val !== "" && val !== "." && !isNaN(Number(val))) {
//                       onChangeInput(Number(val), isUp ? 0 : 1, {
//                         inputFocusedUp: focused && isUp,
//                         inputFocusedDown: focused && !isUp,
//                       });
//                     }
//                   }
//                 }}
//               />
//             )}
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CurrenciesSelector;

import React, { useEffect, useRef, useState } from "react";
import { CryptoData, Currency } from "@/types/Currency.tsx";
import GenericApi from "@/api/genericApi";
import {
  CryptoDataQueryKey,
  ExchangeSettingsQueryKey,
} from "@/config/constants/QueryKeys";
import { ApiResponse } from "@/types/Api";
import { useQuery } from "@tanstack/react-query";
import CurrencyOption from "./CurrencyOption";
import { Balance } from "@/types/Balance.tsx";
import { ApiRoutes } from "@/config/routes/ApiRoutes";
import { ExchangeSettings } from "@/types/Exchange";
import { isBitramp, isSNS } from "@/utils/utils";
import { AnimatePresence, motion } from "framer-motion";

interface Props {
  currencie: string;
  name: string;
  editable: boolean;
  options: Currency[];
  onChangeInput: (
    value: number,
    index: number,
    {
      inputFocusedUp,
      inputFocusedDown,
    }: {
      inputFocusedUp: boolean;
      inputFocusedDown: boolean;
    }
  ) => void;
  onChooseOption: (option: Currency, index: number) => void;
  defaultOption: Currency;
  index: number;
  value?: number;
  isLoading: boolean;
  hasError: boolean;
  isUp: boolean;
  currency: string;
  balance: Balance[] | null;
  isPos?: boolean;
}

const CurrenciesSelector: React.FC<Props> = ({
  isUp,
  name,
  options,
  onChooseOption,
  // defaultOption,
  value,
  onChangeInput,
  isLoading,
  hasError,
  currency,
  balance,
}) => {
  const isBej = name.includes("line--bej");

  const selectedBalance = balance?.find((b) => b.currency === currency);
  const [focused, setFocused] = React.useState(false);

  const [isOpen, setIsOpen] = useState(false);
  // const [selectedOption, setSelectedOption] = useState<Currency>({
  //   ...defaultOption,
  // });

  // const debounceValue = useDebounce(value, 500);

  const [isNewFiat, setIsNewFiat] = useState(false);

  const handleOptionClick = (option: Currency) => {
    // setSelectedOption(option);
    setIsOpen(false);
    onChooseOption(option, isUp ? 0 : 1);
    if (option.type === "fiat") {
      setIsNewFiat(true);
    } else {
      setIsNewFiat(false);
    }
  };

  const getVal = (value: number) => {
    const valueAsString = String(value);

    if (valueAsString === "0") {
      return "";
    }

    if (valueAsString[0] === "0" && valueAsString[1] !== ".") {
      return valueAsString.slice(1);
    }

    return valueAsString;
  };

  const url = `https://min-api.cryptocompare.com/data`;

  const { data: cryptoData, error } = useQuery<ApiResponse<CryptoData>>({
    queryFn: async () =>
      GenericApi.get<CryptoData>(
        `/pricemultifull?fsyms=${currency}&tsyms=${currency}`,
        url
      ),
    queryKey: [CryptoDataQueryKey, currency],
  });

  const [inputValue, setInputValue] = useState<string>("");
  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);

  const { data: exchangeSettings } = useQuery<ApiResponse<ExchangeSettings>>({
    queryFn: async () =>
      GenericApi.get<ExchangeSettings>(ApiRoutes.EXCHANGESETTINGS),
    queryKey: [ExchangeSettingsQueryKey],
  });

  useEffect(() => {
    setInputValue(getVal(value ?? 0));
  }, [value]);

  const getMediaLink = () => {
    if (currency) {
      return cryptoData?.data?.RAW?.[currency]?.[currency]?.IMAGEURL;
    }

    return null;
  };

  const mediaLink = getMediaLink();

  const flagUrls: Record<string, string> = {
    EUR: "https://flagcdn.com/w320/eu.png",
    USD: "https://flagcdn.com/w320/us.png",
    RON: "https://flagcdn.com/w320/ro.png",
    GBP: "https://flagcdn.com/w320/gb.png",
    JPY: "https://flagcdn.com/w320/jp.png",
    PLN: "https://flagcdn.com/w320/pl.png",
    AUD: "https://flagcdn.com/w320/au.png",
    CAD: "https://flagcdn.com/w320/ca.png",
    CHF: "https://flagcdn.com/w320/ch.png",
    // Adaugă aici alte monede relevante
  };

  const imageUrl = flagUrls?.[currency]
    ? flagUrls[currency] // Use flag URL if available
    : mediaLink
    ? `https://www.cryptocompare.com${mediaLink}`
    : "https://via.placeholder.com/24";

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // if up is fiat, filter options to only include fiat currencies and down to only include non-fiat currencies

  if (error || cryptoData?.error) {
    return <div>{cryptoData?.error?.message ?? "Something went wrong"}</div>;
  }

  //   return (
  //     <div className={`${name} flex flex-col gap-1`}>
  //       <div className="text-left w-full text-[1rem] font-[400] pb-[8px]">
  //         {isUp ? "You send" : "You get"}
  //       </div>
  //       <div className="flex justify-between w-full pb-[1rem]">
  //         <div
  //           className={`currenciesSelector ${
  //             isBej ? "currenciesSelector--bej" : ""
  //           }`}
  //           onMouseEnter={handleMouseEnter}
  //           onMouseLeave={handleMouseLeave}
  //         >
  //           <div className="z-up">
  //             <div className="circle">
  //               {" "}
  //               <img
  //                 className="w-[55px] h-[55px] rounded-full object-cover"
  //                 src={imageUrl}
  //                 alt="Crypto"
  //               />
  //             </div>
  //           </div>
  //           <div className="w-full`">
  //             <div className="flex gap-4 items-center w-fit">
  //               <div
  //                 data-text={selectedOption.code}
  //                 className="z-up text flex flex-col items-start justify-start"
  //               >
  //                 {selectedOption.code}
  //               </div>

  //               <div>
  //                 <svg
  //                   width="13"
  //                   height="11"
  //                   viewBox="0 0 13 11"
  //                   fill="none"
  //                   xmlns="http://www.w3.org/2000/svg"
  //                   className={isOpen ? "rotate180" : "reverseRotate180"}
  //                 >
  //                   <path
  //                     id="Polygon 3"
  //                     d="M7.35044 9.6252C6.95955 10.2571 6.04045 10.2571 5.64956 9.6252L0.948823 2.02607C0.536717 1.35987 1.0159 0.5 1.79926 0.5L11.2007 0.500001C11.9841 0.500001 12.4633 1.35987 12.0512 2.02607L7.35044 9.6252Z"
  //                     fill="#222B45"
  //                   />
  //                 </svg>
  //               </div>
  //             </div>

  //             {isUp ? (
  //               <div className="flex justify-start items-center gap-2 w-full absolute left-[75px]">
  //                 {exchangeSettings?.data?.balance_enabled === true && (
  //                   <span className="text-[#C2C2C2] font-normal text-lg text-nowrap">
  //                     {!isNewFiat
  //                       ? `Balance: ${
  //                           Number(selectedBalance?.balance).toFixed(4) ?? "N/A"
  //                         }
  //                   ${selectedBalance?.currency ?? "N/A"}`
  //                       : ""}
  //                   </span>
  //                 )}
  //               </div>
  //             ) : (
  //               <div></div>
  //             )}
  //           </div>
  //           {isOpen && (
  //             <div className="dropDownComponent__menu__currencies ">
  //               {options.map((option) => (
  //                 <CurrencyOption
  //                   option={option}
  //                   handleClickOption={handleOptionClick}
  //                   key={option.code}
  //                 />
  //               ))}
  //             </div>
  //           )}
  //         </div>

  //         <div className="">
  //           <form>
  //             {isLoading && !focused ? (
  //               <div
  //                 className="inline-block h-10 w-10 animate-spin rounded-full border-[7px] border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
  //                 role="status"
  //               >
  //                 <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
  //                   Loading...
  //                 </span>
  //               </div>
  //             ) : hasError && !focused ? (
  //               <div className="text-red-500">No rate found</div>
  //             ) : (
  //               <input
  //                 onFocus={onFocus}
  //                 onBlur={onBlur}
  //                 className="inputNumber !text-[1.75rem]"
  //                 type="text"
  //                 id="number"
  //                 step="any"
  //                 placeholder="0"
  //                 name="number"
  //                 min="0"
  //                 autoComplete="off"
  //                 value={inputValue}
  //                 onChange={(e) => {
  //                   const val = e.target.value.replace(",", ".");

  //                   // Reject anything with multiple leading zeros (except "0", "0.xxx")
  //                   const valid = /^([1-9]\d*|0)?(\.\d*)?$/.test(val);

  //                   if (val === "" || valid) {
  //                     setInputValue(val);

  //                     // Trigger change only if valid number (not just ".", empty)
  //                     if (val !== "" && val !== "." && !isNaN(Number(val))) {
  //                       onChangeInput(Number(val), isUp ? 0 : 1, {
  //                         inputFocusedUp: focused && isUp,
  //                         inputFocusedDown: focused && !isUp,
  //                       });
  //                     }
  //                   }
  //                 }}
  //               />
  //             )}
  //           </form>
  //         </div>
  //       </div>
  //     </div>
  //   );

  return (
    <div className={`${name} flex flex-col gap-1`}>
      <div
        className={`text-left w-full Text regular mt-2 ${
          isSNS() ? "text-[#727272] font-[inter]" : "text-black"
        }
        ${isBitramp() ? "!text-[#fff]" : ""}`}
      >
        {isUp ? "You send" : "You get"}
      </div>
      <div className="flex justify-between  w-full pb-[1rem] cursor-pointer">
        <div
          className={`currenciesSelector ${
            isBej ? "currenciesSelector--bej" : ""
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="z-up">
            <img
              className="!w-[50px] !h-[50px] max-w-[50px] rounded-full object-cover"
              src={imageUrl}
              alt="Crypto"
            />
          </div>
          <div className="w-full ">
            <div
              className={`${
                isSNS() ? "text-white" : "dark-blue"
              } flex gap-4 items-center justify-start  w-fit Title font-[900]`}
            >
              {/* <div
                data-text={selectedOption.code}
                className="z-up text flex flex-col items-start justify-start"
              >
                {selectedOption.code}
              </div> */}

              <div
                data-text={currency}
                className="z-up ml-4 flex flex-col !text-[1.9rem] items-center justify-start mt-1"
              >
                {currency}
              </div>

              <div>
                {isSNS() ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                  >
                    <path
                      d="M10.6961 0.144357L5.54772 5.29275L0.402913 0.147951L0.402114 4.95086L5.55131 10.1001L10.6931 4.95825L10.6961 0.144357Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="11"
                    viewBox="0 0 13 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={
                      isOpen ? "rotate180 mt-1" : "reverseRotate180 mt-1"
                    }
                  >
                    <path
                      id="Polygon 3"
                      d="M7.35044 9.6252C6.95955 10.2571 6.04045 10.2571 5.64956 9.6252L0.948823 2.02607C0.536717 1.35987 1.0159 0.5 1.79926 0.5L11.2007 0.500001C11.9841 0.500001 12.4633 1.35987 12.0512 2.02607L7.35044 9.6252Z"
                      fill={`${isBitramp() ? "white" : "#222B45"}`}
                    />
                  </svg>
                )}
              </div>
            </div>

            {isUp ? (
              <div className="flex justify-start items-center gap-2 w-full absolute left-[67px]">
                {exchangeSettings?.data?.balance_enabled === true && (
                  <span className="text-[#C2C2C2] font-normal text-lg text-nowrap">
                    {!isNewFiat
                      ? `Balance: ${
                          Number(selectedBalance?.balance).toFixed(4) ?? "N/A"
                        }
                  ${selectedBalance?.currency ?? "N/A"}`
                      : ""}
                  </span>
                )}
              </div>
            ) : (
              <div></div>
            )}
          </div>
          {/* {isOpen && (
            <div
              // className={`dropDownComponent__menu__currencies ${
              //   isSNS() ? "bg-[#383838] border border-[#383838]" : ""
              // }`}
              className={`
                dropDownComponent__menu__currencies top-full left-0  !max-h-[300px] overflow-y-auto rounded-[0.625rem]
                ${isSNS() ? "bg-[#383838] border-[#383838]" : ""}
                ${
                  isBitramp()
                    ? "bg-[#2b2b2b] !border-[rgba(255,255,255,0.1)] crypto-list_bitramp"
                    : ""
                }
              `}
              style={{
                position: "absolute",
                top: "100%",
                left: "0",
                marginTop: "8px",
                zIndex: 9999,
              }}
            >
              {options.map((option) => (
                <div className="flex flex-col gap-1 w-full pr-2">
                  <div
                    className={`w-full h-[1px]  ${
                      isBitramp()
                        ? "bg-[rgba(255,255,255,0.1)]"
                        : "bg-[#efefef]"
                    }`}
                  ></div>
                  <CurrencyOption
                    option={option}
                    handleClickOption={handleOptionClick}
                    key={option.code}
                  />
                </div>
              ))}
            </div>
          )} */}
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0, y: -8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.2 }}
                className="absolute top-full left-0 GlassContainerc dark-blue pshadow z-10 h-[13rem] flex justify-center items-center w-full"
              >
                <motion.div
                  ref={dropdownRef}
                  initial={{ opacity: 0, y: -8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -8 }}
                  transition={{ duration: 0.2 }}
                  className={`dark-blue w-[93%] z-10 h-[12rem] overflow-y-auto ${
                    isBitramp() ? "crypto-list_bitramp" : "crypto-list-gray"
                  }`}
                >
                  {options.map((option) => (
                    <div className="flex flex-col gap-1 w-full pr-2">
                      <CurrencyOption
                        option={option}
                        handleClickOption={handleOptionClick}
                        key={option.code}
                      />
                    </div>
                  ))}
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <div className="">
          <form>
            {isLoading && !focused ? (
              <div
                className={`${
                  isBitramp() ? "text-[#EE33D9]" : ""
                } inline-block h-10 w-10 animate-spin rounded-full border-[7px] border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white`}
                role="status"
              >
                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                  Loading...
                </span>
              </div>
            ) : hasError && !focused ? (
              <div className="text-red-500">No rate found</div>
            ) : (
              <input
                onFocus={onFocus}
                onBlur={onBlur}
                className={`inputNumber !py-[0rem] dark-blue text-[1.9rem] ${
                  isSNS() ? "!text-white" : ""
                }`}
                type="number"
                id="number"
                step="any"
                inputMode="decimal"
                placeholder="0"
                name="number"
                min="0"
                autoComplete="off"
                value={inputValue}
                onChange={(e) => {
                  const val = e.target.value.replace(",", ".");

                  // Reject anything with multiple leading zeros (except "0", "0.xxx")
                  const valid = /^([1-9]\d*|0)?(\.\d*)?$/.test(val);

                  if (val === "" || valid) {
                    setInputValue(val);

                    // Trigger change only if valid number (not just ".", empty)
                    if (val !== "" && val !== "." && !isNaN(Number(val))) {
                      onChangeInput(Number(val), isUp ? 0 : 1, {
                        inputFocusedUp: focused && isUp,
                        inputFocusedDown: focused && !isUp,
                      });
                    }
                  }
                }}
              />
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default CurrenciesSelector;
